// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"E5-z"};